import { SidebarMenu } from './sidebar-menu.models';
import { Component, Input, OnDestroy, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { ShellSideNavService } from '../shell-sidenav.service';
import { SettingsService } from '../../core/settings/settings.service';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
declare var $: any;

@Component({
  selector: '[smpSidebarElement]',
  templateUrl: './sidebar-menu-element.component.html'
})

export class SidebarMenuElementComponent implements OnDestroy {

  @Input() elementsToRender: SidebarMenu[];
  @Input() isSubMenu: boolean = false;

  public mobileQuery: MediaQueryList;

  private isMouseOnFloatingNav: boolean = false;

  constructor(
    private router: Router,
    private shellSideNavService: ShellSideNavService,
    private settings: SettingsService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher) {
      this.mobileQuery = media.matchMedia('(max-width: 600px)');
      this.mobileQuery.addListener(() => changeDetectorRef.detectChanges());
  }

  public ngOnDestroy() {
      //this.subscription.unsubscribe();
  }

  private setClasses(element: SidebarMenu) {
    return { 'active': element.isActive, 'open': this.isOpened(element) }
  }

  private isOpened(element: SidebarMenu) {
    return element.childElements && element.childElements.length > 0 && element.expanded;
  }

  private onElementClick(event, element: SidebarMenu) {
    if(event){
      event.preventDefault();
    }

    if (this.showArrow(element)) {
      if(this.settings.getLayoutSetting('isCollapsed') 
      || this.settings.getLayoutSetting('isCollapsedText')
      || this.settings.getLayoutSetting('asideHover')){
        return;
      }
      if (element.childElements.length > 0) {
        let isExpanded = element.expanded;  
        this.elementsToRender.forEach( el => el.expanded = false );      
        element.expanded = !isExpanded;        
      }
    }
    if (element.path) {
      var isOnMobile = this.mobileQuery.matches;
      if(isOnMobile)
      {
        this.settings.setLayoutSetting('asideToggled', false);
      }
      this.shellSideNavService.CloseSideNav();
      this.router.navigate([element.path]);
    }
  }

  private onElementHover(event, element: SidebarMenu) {
    let self = this;
    this.removeFloatingNav();
    if((this.settings.getLayoutSetting('isCollapsed') 
    || this.settings.getLayoutSetting('isCollapsedText')
    || this.settings.getLayoutSetting('asideHover')) 
    && element.childElements.length > 0){
      event.preventDefault();    
      let target = $(event.target);
      this.calculateHoverMenuPosition(target, element);
    }
  }
  
  private onleave(event, element: SidebarMenu) {    
    let self = this;
  }


  private setArrow(element: SidebarMenu) {
    return {
      'fa-angle-right': !element.expanded,
      'fa-angle-down': element.expanded
    };
  }

  private showArrow(element: SidebarMenu) {
    return element.childElements && element.childElements.length > 0;
  }

  private calculateHoverMenuPosition(parent, element: SidebarMenu){
    let target = parent;
    let ul = target;
    let anchor = target;
    // find the UL
    if (!target.is('a')) {
        anchor = target.parent('a');
    }

    ul = $(`<ul class="sidebar-nav sidebar-subnav"></ul>`);

    let $aside = $('.aside-container'); 
    let floatingNav = ul.clone().appendTo($aside); 
    floatingNav.on('mouseleave', function(e,submenu){
      this.removeFloatingNav();
      this.isMouseOnFloatingNav = false;
    }.bind(this));
    floatingNav.on('mouseenter', function(e,submenu){
      this.isMouseOnFloatingNav = true;
    }.bind(this));
    
    element.childElements.forEach(subMenu => {
      let li = $(`<li ></li>`).appendTo(floatingNav);
     
      let a = $(`<a href="${subMenu.path}" mat-ripple title=`+subMenu.name+`>`).appendTo(li);
      a.on('click', function(e) {
          e.preventDefault(); 
          if (subMenu.path) {
            this.shellSideNavService.CloseSideNav();
            this.router.navigate([subMenu.path]);
            this.removeFloatingNav();           
          }
      }.bind(this));
     
      let span = $(`<span>`+subMenu.name+`</span>`).appendTo(a);
    });

    if (!ul.length) {
        return; 
    }
    let liPos = anchor.parent().position().top;
    let parentDivPosition = anchor.parent().parent().parent().parent().position().top // main side div top position
    let $asideInner = $aside.children('.aside-inner'); // for top offset calculation
    let itemTop = ((parentDivPosition) + liPos);
    let vwHeight = $(window).height();
    floatingNav
        .removeClass('opening') // necesary for demo if switched between normal//collapsed mode
        .addClass('nav-floating')
        .css({
            position: this.settings.getLayoutSetting('isFixed') ? 'fixed' : 'absolute',
            top: itemTop,
            bottom: (floatingNav.outerHeight(true) + itemTop > vwHeight) ? 0 : 'auto'
        });
    this.listenForExternalClicks();
  }
  listenForExternalClicks() {
    let $doc = $(document).on('click.sidebar', (e) => {
        if (!$(e.target).parents('.aside-container').length) {
            this.removeFloatingNav();
            $doc.off('click.sidebar');
        }
    });
}

  removeFloatingNav() {
    $('.nav-floating').remove();
  }

  public hideMenuWhenLeaveOutside() {
    setTimeout(() => {
      if(!this.isMouseOnFloatingNav) {
        this.removeFloatingNav();
      }
    }, 100);
  }

  public onElementContextMenu(event){
    event.preventDefault();
  }
}
